
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{attrs:{"transform":"translate(.5)","fill":"#393B40","fill-rule":"evenodd","font-family":"AppleColorEmoji, Apple Color Emoji","font-size":"20"}},[_c('tspan',{attrs:{"x":"0","y":"22"}},[_v('🎬')])])])
          )
        }
      }
    